<template>
  <page>
    <module enable-flex>
      <m-search ref="search" @search="searchHandle">
        <c-form ref="searchForm">
	      <c-form-item type="input" label="会员昵称" name="nick_name">
	      </c-form-item>
		  <c-form-item type="input" label="授权代码" name="login_name">
		  </c-form-item>
	      <c-form-item type="input" label="会员手机号" name="user_manage_mobilephone">
          <c-form-item type="input" label="会员地址"  name="user_address" placeholder=""></c-form-item>
          </c-form-item>
          <c-form-item type="input" label="邀请人手机" name="share_user_manage_mobilephone">
          </c-form-item>
          <c-form-item type="input" label="上级经销商手机" name="leader_user_manage_mobilephone">
          </c-form-item>
          <c-form-item type="select" label="会员等级" name="user_level" options="USER_LEVEL_AUTH">
          </c-form-item>
          <c-form-item type="checkbox" label="用户状态" name="state" :options="stateType" :value="[1]">
          </c-form-item>
          <c-form-item label="货款余额下限：" name="account_balance_min" placeholder="货款余额大于等于该数" type="number" decimal="2" :limit="[0,9999999]"></c-form-item>
          <c-form-item label="货款余额上限："  name="account_balance_max" placeholder="货款余额小于等于该数" type="number" decimal="2" :limit="[0,9999999]"></c-form-item>
        </c-form>
      </m-search>
      <m-operate>
          <c-button v-show="!higherLevel.platform_user_id" power="b_member_user_target_change" color="sys" @click="setSaleTarget()">批量设置销售目标</c-button>
          <c-button v-show="!higherLevel.platform_user_id" power="b_member_user_export" color="black" @click="exportData()">导出</c-button>
          <c-button v-show="higherLevel.platform_user_id" color="black" hollow @click="backHigher">返回</c-button>
            <span v-if="higherLevel.platform_user_id" style="margin-left: 10px; font-size: 13px;">
                上级：{{`${higherLevel.nick_name}(${higherLevel.user_manage_mobilephone})`}}
		    </span>
      </m-operate>
      <c-table ref="table">
        <c-table-column
                  type="selector"
        ></c-table-column>
        <c-table-column label="会员昵称" name="nick_name" width="150">
          <template v-slot="{data}">
            <div class="flex-center-cross">
              <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
              <a  @click="detail(data)" class="s-link">
								{{data.nick_name}}
							</a>
            </div>
          </template>
        </c-table-column>
		<c-table-column label="授权代码" name="login_name" width="100">
		  <template v-slot="{data}">
			<span v-if="data.login_name" >{{data.login_name}}</span>
			<span v-else style="color:#999999">-</span>
		  </template>
		</c-table-column>
        <c-table-column label="会员手机号" name="user_manage_mobilephone" width="120">
          <template v-slot="{data}">
            <a v-if="data.user_level > -99 && data.direct_count > 0" class="s-link"
               @click="loadLower(data)">
              ↓ {{data.user_manage_mobilephone}}
            </a>
            <span v-else-if="data.user_manage_mobilephone">
				{{data.user_manage_mobilephone}}
			</span>
            <span v-else>
				--
			</span>
          </template>
        </c-table-column>
		<c-table-column label="会员等级" name="user_level_name" width="80">
        </c-table-column>
        <c-table-column
              label="会员地址"
              name="user_address"
              width="200"
        >
              <template v-slot="{data}">
                  <span v-if="data.user_address && data.user_address!=''">{{data.user_address}}</span>
                  <span v-else>--</span>
              </template>
        </c-table-column>
		
        <c-table-column label="邀请会员数" name="direct_count" width="90">
          <template v-slot="{data}">
            <a v-if="data.user_level >-99 && data.direct_count > 0" class="s-link"
               @click="loadLower(data)">
              &nbsp;↓&nbsp; {{data.direct_count}}
            </a>
            <span v-else>
							{{data.direct_count}}
						</span>
          </template>
        </c-table-column>
		
		<c-table-column label="邀请人" name="share_user_manage_mobilephone" width="150">
		  <template v-slot="{data}">
				<span v-if="data.platform_user_id==-1" style="color:#bbb">-</span>
				<span v-else>
					<span>代码：{{data.share_user_name}}</span><br/>
					<span>昵称：{{data.share_user_nick_name}}</span><br/>
					<span>手机：{{data.share_user_manage_mobilephone}}</span><br/>
					<span>等级：{{data.share_user_level_name}}</span>
				</span>
		  </template>
		</c-table-column>
		
		<c-table-column label="上级经销商" name="leader_user_manage_mobilephone" width="150">
		  <template v-slot="{data}">
				<span v-if="data.user_level==4" style="color:#bbb">-</span>
				<span v-else>
					<span>代码：{{data.leader_user_name}}</span><br/>
					<span>昵称：{{data.leader_user_nick_name}}</span><br/>
					<span>手机：{{data.leader_user_manage_mobilephone}}</span><br/>
					<span>等级：{{data.leader_user_level_name}}</span>
				</span>
		  </template>
		</c-table-column>
		
        <!-- <c-table-column label="间推会员" name="indirect_count" width="70">
        </c-table-column> -->
        <c-table-column label="状态" name="state" width="60">
          <template v-slot="{data}">
            <span v-if="data.state == 2" style="color:red">禁用</span>
            <span v-if="data.state == 1" style="color:green">启用</span>
          </template>
        </c-table-column>
		
		<c-table-column
			label="货款余额(元)"
			name="account_balance"
			width="100"
		>
			<template v-slot="{data}">
				￥{{(data.account_balance||0).toFixed(2)}}
			</template>
		</c-table-column>
		
        <c-table-column label="收益余额(元)" name="account" width="100">
          <template v-slot="{data}">
            ￥{{(data.reward_balance||0).toFixed(2)}}
          </template>
        </c-table-column>
		
		<c-table-column label="积分余额" name="account" width="80">
		  <template v-slot="{data}">
		    {{(data.jf_balance||0).toFixed(2)}}
		  </template>
		</c-table-column>
		
		<c-table-column
			label="月度目标"
			width="100"
		>
			<template v-slot="{data}">
				<span v-if="(data.user_level == 3 || data.user_level == 4 )&& data.month_target">￥{{(data.month_target||0).toFixed(2)}}</span>
				<span v-else style="color:#999">-</span>
			</template>
		</c-table-column>
		
		<c-table-column
			label="季度目标"
			width="105"
		>
			<template v-slot="{data}">
				<span v-if="(data.user_level == 3 || data.user_level == 4 )&& data.quarterly_target">￥{{(data.quarterly_target||0).toFixed(2)}}</span>
				<span v-else style="color:#999">-</span>
			</template>
		</c-table-column>
		
		<c-table-column
			label="年度目标"
			width="110"
		>
			<template v-slot="{data}">
				<span v-if="(data.user_level == 3 || data.user_level == 4 )&& data.year_target">￥{{(data.year_target||0).toFixed(2)}}</span>
				<span v-else style="color:#999">-</span>
			</template>
		</c-table-column>

        <c-table-column label="加入会员时间" name="upgrade_date" width="150">
        </c-table-column>

        <c-table-column type="button" fixed="right" label="操作" width="240" limit="10">
          <template v-slot="{data}" >
			<!-- <c-table-button power="b_member_user_view" @click="detail(data)" v-if="data.platform_user_id > 0">详情</c-table-button> -->
			<c-table-button power="b_member_user_edit_info" @click="setBaseInfo(data)">修改会员资料</c-table-button>
            <c-table-button power="b_member_user_view_symx" @click="viewReward(data)"> 收益明细 </c-table-button>
            <c-table-button power="b_member_user_change" v-if="data.platform_user_id > 0" @click="setMember(data)">会员调整</c-table-button>
			<c-table-button power="b_member_user_stock_change" v-if="data.user_level == 3 || data.user_level == 4" @click="setStock(data)">云仓库存</c-table-button>
			<c-table-button power="b_member_user_stock_lade" v-if="data.user_level == 3 || data.user_level == 4" @click="navigateTo(`/lade_user_stock/${data.platform_user_id}`)">云仓提货</c-table-button>
			<c-table-button power="b_member_user_target_change" v-if="data.user_level == 3 || data.user_level == 4" @click="setSaleTarget(data)">销售目标</c-table-button>
            <c-table-button power="b_member_upgrade_record" @click="viewUpgradeRecord(data)">调整日志 </c-table-button>
          </template>
        </c-table-column>
      </c-table>
    </module>
	
    <c-dialog ref="rewardDialog" title="收益明细" width="1200" height="800" enable-flex :button="false">
		  <m-search ref="rewardSearch" @search="rewardSearchHandle">
			<c-form ref="form" inline>
			  <c-form-item type="checkbox" label="收益类型" name="reward_type" :options="rewardType">
			  </c-form-item>
			  <c-form-item type="checkbox" label="状态" name="state" :options="rewardState">
			  </c-form-item>
			  <c-form-item type="datetime" label="创建时间" start-name="start_date" end-name="end_date">
			  </c-form-item>
			</c-form>
		  </m-search>
		  <c-table ref="rewardTable" height="grow">
			<c-table-column label="单号" width="150" name="record_number">
			</c-table-column>
			<c-table-column label="收益类型" width="100" name="reward_type">
				<template v-slot="{data}">
					<span v-if="data.reward_type==1">分销差价</span>
					<span v-if="data.reward_type==2">直推奖励</span>
					<span v-if="data.reward_type==3">间推奖励</span>
					<span v-if="data.reward_type==7">直推平级奖励</span>
					<span v-if="data.reward_type==8">间推平级奖励</span>
			  </template>
			</c-table-column>
			<c-table-column label="收益金额" name="record_money" width="120">
			  <template v-slot="{data}">
				<span v-if="data.state==0">￥{{(data.estimated_record_money||0).toFixed(2)}}</span>
				<span v-if="data.state==1"><span style="color:darkgray">[预估]</span>￥{{(data.estimated_record_money||0).toFixed(2)}}</span>
				<span v-if="data.state==2">￥{{(data.record_money||0).toFixed(2)}}</span>
			  </template>
			</c-table-column>
			<c-table-column label="收益状态" name="state" width="75">
			  <template v-slot="{data}">
					<span v-if="data.state==0" style="color:#aaaaaa">{{rewardStateMap[data.state]}}</span>
					<span v-if="data.state==1" style="color:sandybrown">{{rewardStateMap[data.state]}}</span>
					<span v-if="data.state==2" style="color:darkgreen">{{rewardStateMap[data.state]}}</span>
			  </template>
			</c-table-column>
			<c-table-column label="关联用户" name="nick_name" width="250">
			  <template v-slot="{data}">
				{{data.nick_name}}【<font color="#999">{{data.user_manage_mobilephone||'-'}}</font>】
			  </template>
			</c-table-column>
			<c-table-column label="关联等级" name="level_name" width="80">
			  <template v-slot="{data}">
					<span v-if="data.reward_type == 1 || data.reward_type == 2 || data.reward_type == 3 || data.reward_type == 6 || data.reward_type == 7 || data.reward_type == 8">{{data.level_name}}</span>
					<span v-else>--</span>
			  </template>
			</c-table-column>
			<c-table-column label="关联单号" name="relate_number" width="150">
			</c-table-column>
			<c-table-column label="供货单号" name="relate_number" width="150">
				<template v-slot="{data}">
					<span v-if="data.reward_type == 1 || data.reward_type == 6">{{data.sub_order_number}}</span>
					<span v-else>-</span>
				</template>
			</c-table-column>
		   <!-- <c-table-column label="商品原价" name="original_product_money" width="95">
			  <template v-slot="{data}">
							<span v-if="data.reward_type == 1 || data.reward_type == 5">
				  ￥{{(data.original_product_money||0).toFixed(2)}}
							</span>
				<span v-else>
								--
							</span>
			  </template>
			</c-table-column> -->
			<c-table-column label="商品成交价" name="product_money" width="95">
			  <template v-slot="{data}">
							<span v-if="data.reward_type == 1 || data.reward_type == 4 || data.reward_type == 5 || data.reward_type == 6 || data.reward_type == 7 || data.reward_type == 8">
								￥{{(data.product_money||0).toFixed(2)}}
							</span>
							<span v-else>-</span>
			  </template>
			</c-table-column>
			<c-table-column label="收益时间" name="create_date" width="155">
			</c-table-column>
			<c-table-column label="到账时间" name="settlement_date" width="155">
			  <template v-slot="{data}">
				{{data.settlement_date||'-'}}
			  </template>
			</c-table-column>
			<c-table-column label="备注" name="remark" width="350">
			  <template v-slot="{data}">
				{{data.remark||'-'}}
			  </template>
			</c-table-column>
		  </c-table>
    </c-dialog>

    <c-dialog ref="upgradeRecordDialog" title="会员调整日志" width="1200" height="800" enable-flex :button="false">
		  <c-table ref="upgradeRecordTable" height="grow">
			<c-table-column label="调整类型" width="80" name="reward_type">
				<template v-slot="{data}">
					<span v-if="data.upgrade_type==1">用户注册</span>
					<span v-if="data.upgrade_type==2">总后台变更</span>
					<span v-if="data.upgrade_type==3">购买会员升级</span>
					<span v-if="data.upgrade_type==6">上级经销商调整</span>
					<span v-if="data.upgrade_type==7">邀请保护期过期</span>
			  </template>
			</c-table-column>
            <c-table-column label="调整前等级" name="pre_level_name" width="90"></c-table-column>
            <c-table-column label="调整后等级" name="upgrade_level_name" width="90"></c-table-column>
			<c-table-column label="调整前分享人" width="160">
                <template v-slot="{data}">
                    <div class="flex-center-cross">
                        <c-image :src="data.pre_share_user_head_photo" preview size="30" style="margin-right: 10px;"> </c-image>
                        <span v-if="data.pre_share_user_nick_name && data.pre_share_user_nick_name!=''">{{data.pre_share_user_nick_name}}</span>
                        <span v-else>--</span>
                        <span v-if="data.pre_share_user_phone">{{data.pre_share_user_phone}}</span>
                    </div>
                </template>
			</c-table-column>
			<c-table-column label="调整后分享人" width="160">
                <template v-slot="{data}">
                    <div class="flex-center-cross">
                        <c-image :src="data.upgrade_share_user_head_photo" preview size="30" style="margin-right: 10px;"> </c-image>
                        <span v-if="data.upgrade_share_user_nick_name && data.upgrade_share_user_nick_name!=''">{{data.upgrade_share_user_nick_name}}</span>
                        <span v-else>--</span>
                        <span v-if="data.upgrade_share_user_phone">{{data.upgrade_share_user_phone}}</span>
                    </div>
                </template>
			</c-table-column>
            <c-table-column label="调整处理人" width="160">
                  <template v-slot="{data}">
                      <div class="flex-center-cross" v-if="data.upgrade_type==2 || data.upgrade_type==6">
                          <c-image v-if="data.create_user_head_photo" :src="data.create_user_head_photo" preview size="30" style="margin-right: 10px;"> </c-image>
                          <span v-if="data.create_user_name && data.create_user_name!=''">{{data.create_user_name}}</span>
                          <span v-else>--</span>
                          <span v-if="data.create_user_phone">{{data.create_user_phone}}</span>
                      </div>
                      <div v-else>--</div>
                  </template>
            </c-table-column>
			<c-table-column label="调整时间" name="create_date" width="155"></c-table-column>
		  </c-table>
    </c-dialog>

    <c-dialog ref="memberDialog" title="调整会员邀请人/等级" width="600" @resolve="setMemberHandle">
      <c-form ref="memberForm">
        <c-form title="会员信息" title-margin="10">
          <c-form-item type="input" label="会员昵称:" name="nick_name" disabled> </c-form-item>
          <c-form-item type="input" label="会员手机号:" name="user_manage_mobilephone" disabled> </c-form-item>
        </c-form>
        <c-form title="邀请人" title-margin="10">
          <c-form-item type="input" label="当前邀请人:" name="share_user_name" disabled> </c-form-item>
          <c-form-item type="hidden" name="share_user_id"></c-form-item>
          <c-form-item type="input" @click="$refs.memberUserSelector.open()" readonly label="修改为:" name="tran_share_user_name" required word="调整后该用户后续带来的收益奖归于新的邀请人下">
          </c-form-item>
        </c-form>
        <c-form title="会员等级" title-margin="10">
          <c-form-item type="input" label="当前等级:" name="user_level_name" disabled></c-form-item>
          <c-form-item type="select" label="调整为:" name="user_level" options="USER_LEVEL_AUTH" required></c-form-item>
        </c-form>
      </c-form>
    </c-dialog>
	
    <member-user-selector ref="memberUserSelector" @resolve="selectHandle($event, 'memberList', 'platform_user_id')"></member-user-selector>
	
	<c-dialog ref="stockEdit" title="云仓库存调整" width="1000" height="700" enable-flex  @resolve="setStockHandle">
		<m-search ref="stockSearch" @search="stockSearchHandle">
		  <c-form ref="stockForm" inline>
			<c-form-item type="input" label="商品名称" name="product_name"> </c-form-item>
              <c-form-item type="select" label="可售范围" name="visible_user_type" :options="visibleUserType"></c-form-item>
<!--
              <c-form-item type="input" label="商品规格" name="product_sku_spec"> </c-form-item>
-->
			<c-form-item type="input" label="SKU编码" name="product_sku_code"> </c-form-item>
		    <c-form-item type="checkbox" label="" name="isStock" :options="[{name: '有库存',value: 1}]"></c-form-item>
		  </c-form>
		</m-search>
		<c-table ref="stockTable" height="500">
			<c-table-column
				label="商品信息"
				name="product_name"
				width="300"
			>
				<template v-slot="{data}">
					<product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
					<product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
				</template>
			</c-table-column>

            <c-table-column
                    label="可售范围"
                    name="visible_user_type"
                    width="70"
            >
                <template v-slot="{data}">
                    <span v-if="data.visible_user_type == 0">所有用户</span>
                    <span v-if="data.visible_user_type == 1" style="color:blue">普通用户</span>
                    <span v-if="data.visible_user_type == 2" style="color:green">经销商</span>
                </template>
            </c-table-column>
			
			<c-table-column
				label="规格名称"
				name="product_sku_spec"
				width="120"
			></c-table-column>

			<c-table-column
				label="SKU编码"
				name="product_sku_code"
				width="150"
			></c-table-column>

			<c-table-column
				label="当前库存"
				name="product_sku_stock"
				width="70"
			>
			</c-table-column>
	
			<c-table-column
				width="100"
			>
				<template slot="head">
					<div class="flex-center-cross">
						<span>增减库存</span>
						<a style="margin-left: 10px;" @click="$refs.batchStockDialog.open()"><i class="tf tf-edit"></i></a>
					</div>
				</template>
				<template v-slot="{data}">
					<c-input v-model="data.revise_stock" type="number" :limit="[-data.product_sku_stock, 9999]"></c-input>
				</template>
			</c-table-column>
	
			<c-table-column
				label="调整后库存"
				name="product_sku_stock"
				width="120"
			>
				<template v-slot="{data}">
					{{parseInt(data.product_sku_stock) + (parseInt(data.revise_stock) || 0)}}
				</template>
			</c-table-column>
		</c-table>
	</c-dialog>
	
	<c-dialog ref="batchStockDialog" title="批量增减库存" width="400" height="140" @resolve="batchSetStock">
	    <c-form ref="batchStockForm">
			<c-form-item type="number" label="增减库存" name="value"></c-form-item>
		</c-form>
	</c-dialog>
	
	<c-dialog ref="saleTargetDialog" :title="targetDialogTitle" width="600" @resolve="setSaleTargetHandle">
		<c-form ref="saleTargetForm">
            <c-form-item type="select" label="会员等级" name="target_user_level" v-show="this.target_user_type == 2" :options="targetLevelOptions"></c-form-item>
			<c-form-item type="number" label="月度销售目标:" name="month_target" unit="元"> </c-form-item>
			<c-form-item type="number" label="季度销售目标:" name="quarterly_target"> </c-form-item>
			<c-form-item type="number" label="年度销售目标:" name="year_target"> </c-form-item>
		</c-form>
	</c-dialog>
	
	<c-dialog ref="baseInfoDialog" title="修改会员资料" width="600" @resolve="setBaseInfoHandle">
		<c-form ref="baseInfoForm">
			<c-form-item type="input" label="授权代码:" name="login_name" required> </c-form-item>
			<c-form-item type="input" label="手机号码:" name="user_manage_mobilephone" required> </c-form-item>
			<c-form-item type="input" label="昵称:" name="nick_name" required> </c-form-item>
			<c-form-item type="region" label="地址"
			             province-name="province_id"
			             city-name="city_id"
			             county-name="county_id"
			             ></c-form-item>
			<c-form-item type="input" label="地址详情" name="address_detail"></c-form-item>
			<c-form-item type="textarea" v-model="analysis_text"  placeholder="请填入收件人姓名、电话、地址信息，系统将自动识别"></c-form-item>
			<m-operate style="position: absolute;right: 0;">
			    <c-button color="red" @click="analysisAddress()" style="margin-right:16px;margin-top:-50px">智能识别</c-button>
			</m-operate>
		</c-form>
	</c-dialog>
  </page>
</template>
<script>
	import productInfo from '@/components/public/product_info.vue'
	import memberUserSelector from '@/components/service/member_user_selector.vue'
export
default {
  name: 'm_member_user',

  components: {
		productInfo, memberUserSelector
  },

  data() {
    return {
      rewardState: [{
        name: '已取消',
        value: 0
      }, {
        name: '待到账',
        value: 1
      }, {
        name: '已到账',
        value: 2
      }],
      rewardStateMap: {
        '0': '已取消',
        '1': '待到账',
        '2': '已到账'
      },
      rewardType: [{
			name: '分销差价',
			value: 1
		  }, {
			name: '直推奖励',
			value: 2
		  }, {
		    name: '间推奖励',
		    value: 3
		  },{
		     name: '直推平级奖励',
		     value: 7,
		   },{
		     name: '间推平级奖励',
		     value: 8,
		   }],
		  stateType: [{
			name: '启用',
			value: 1
		  }, {
			name: '禁用',
			value: 2
      }],
      levelList: [],
	  levelParams: {},
      member_user_id: '',
      recommend_type: '',
      analysis_text:'',
      visibleUserType: [{
        name: '所有用户',
        value: -1
      }, {
            name: '普通用户',
            value: 1
      }, {
            name: '经销商',
            value: 2
      }],
      targetLevelOptions:[
            {name: '一级代理',value:3},
            {name: '总经销',value:4}
      ],
      target_user_type:1,//设置会员销售目标方式  1=按用户设置 2=设置某个等级所有用户
    }
  },

  computed: {
	    higherLevel() {
	        return this.levelList[this.levelList.length - 1] || {};
	    },
        targetDialogTitle(){
            return {
                1:'【按用户】设置销售目标',
                2:'【按等级】设置销售目标'
            }[this.target_user_type];
        }
  },

  watch: {
	higherLevel(val) {
		this.$refs.search.clear();
		let id = val.platform_user_id || 0;
		this.levelParams[id] && this.levelParams[id].searchParams && this.$refs.searchForm.set(this.levelParams[id].searchParams);
		this.$nextTick(() => {
			this.$refs.search.search(this.levelParams[id] ? this.levelParams[id].pageIndex : 1)
		})
	}
  },

  mounted() {
    this.$refs.search.search();
  },

  methods: {
    selectHandle(list, ref, key) {
      var tran_share_user_name = "--";
      var share_user_id = -1;
      if (list && list[0]){
        tran_share_user_name = (list[0].nick_name || "--") + "【" + (list[0].user_manage_mobilephone||"--") + "】";
        share_user_id = list[0].platform_user_id||-1;
      }
      this.$refs.memberForm.set({
        tran_share_user_name: tran_share_user_name,
        share_user_id: share_user_id,
      });
    },

    setMemberHandle(stop) {
      stop();
      this.$refs.memberForm.submit({
        url: '/member_user/adjustment',
        rule: {
          share_user_id: '请设置邀请人',
          user_level: '请设置等级',
        },
        dataFormatter: data => {
          data.member_user_id = this._edit.platform_user_id;
          delete data.tran_share_user_name;
          return data;
        },

        success: data => {
          this.$refs.memberDialog.close();
          this.$message({
            text: '请求发送成功，调整结果可能稍有延迟!'
          });
          //延迟500ms刷新页面
          setTimeout(() => {
            this.$refs.table.update();
          }, 1000);
        }
      })
    },
	
	//销售目标设置（弹框）
	setSaleTarget(data){
        this.$refs.saleTargetForm.clear();
        if (data){
            this.target_user_type = 1;
            this._setUserIds = [];
            this._setUserIds.push(data.platform_user_id);
            this.$refs.saleTargetForm.set(data);
        }else {
            var list = this.$refs.table.getRow('selected');
            if (!list.length) {
                this.target_user_type = 2;
            }else {
                this.target_user_type = 1;
                for(let i = 0;i<list.length;i++){
                    if(list[i].data.user_level != 3 && list[i].data.user_level != 4){
                        this.$message({
                            text: '请选择【总经销】或【一级代理】等级会员进行销售目标设置'
                        });
                        return;
                    }
                }
                this._setUserIds = Array.from(list,item=>{
                    return item.data.platform_user_id;
                })
            }
        }
		this.$refs.saleTargetDialog.open();
	},
	
	//销售目标设置（提交）
	setSaleTargetHandle(stop) {
	  stop();
	  this.$refs.saleTargetForm.submit({
	    url: '/member_user/set_sale_target',
	    rule: {
           target_user_level: [{
                type: 'empty',
                word: '请选择需要重新设置月度销售目标的会员等级',
                skip: () => {
                    return this.visible_user_type == 1
                }
          }],
	      month_target: '请设置月度销售目标',
	      quarterly_target: '请设置季度销售目标',
		  year_target: '请设置年度销售目标'
	    },
	    dataFormatter: data => {
			data.target_user_type = this.target_user_type;
			data.member_user_ids = this._setUserIds;
	      return data;
	    },
	
	    success: data => {
			this.$refs.saleTargetDialog.close();
			this.$message({
				text: '销售目标设置成功!'
			});
	        this.$refs.table.update();
	    }
	  })
	},
	
	//会员资料编辑（弹框）
	setBaseInfo(data){
		this._setUserIds = data.platform_user_id;
		this.$refs.baseInfoForm.clear();
		this.$refs.baseInfoForm.set(data);
		this.$refs.baseInfoDialog.open();
	},
	
	//会员资料编辑（提交）
	setBaseInfoHandle(stop) {
	  stop();
	  this.$refs.baseInfoForm.submit({
	    url: '/member_user/edit_user_info',
	    rule: {
	      login_name: '请输入会员授权代码',
		  user_manage_mobilephone: '请输入会员手机号码',
		  nick_name: '请输入会员昵称'
	    },
	    dataFormatter: data => {
			data.member_user_id = this._setUserIds;
	      return data;
	    },
	
	    success: data => {
			this.$refs.baseInfoDialog.close();
			this.$message({
				text: '会员资料编辑成功!'
			});
			this.$refs.table.update();
	    }
	  })
	},

    setMember(data) {
      this.$refs.memberForm.clear();
      this._edit = data;
      this.$refs.memberForm.set({
        share_user_name: (data.share_user_nick_name || "") + "【" + (data.share_user_manage_mobilephone||'--') + "】",
        tran_share_user_name: (data.share_user_nick_name || "") + "【" + (data.share_user_manage_mobilephone||'--') + "】",
	    user_level_name: data.user_level_name||'普通用户',
        share_user_id: data.share_user_id,
        nick_name: data.nick_name,
		user_level: data.user_level,
        user_manage_mobilephone: data.user_manage_mobilephone
      });
      this.$refs.memberDialog.open();
    },

    viewReward(val) {
      this.$refs.rewardDialog.open();
      this.member_user_id = val.platform_user_id;
      this.$refs.rewardTable.load({
        url: '/member_user/reward/list',
        data: {
          member_user_id: val.platform_user_id,
        }
      });
    },
    //查询会员调整日志
    viewUpgradeRecord(val) {
      this.$refs.upgradeRecordDialog.open();
      this.member_user_id = val.platform_user_id;
      this.$refs.upgradeRecordTable.load({
        url: '/member_user/upgrade/record/list',
        data: {
          member_user_id: val.platform_user_id,
        }
      });
    },

    rewardSearchHandle(data) {
      data.member_user_id = this.member_user_id;
      this.$refs.rewardTable.load({
        url: '/member_user/reward/list',
        data
      });
    },

    searchHandle(data = {}, page) {
	      data.member_user_id = this.higherLevel.platform_user_id;
	      this.$refs.table.load({
	        url: '/member_user/list',
	        data
	      }, page);
          this.searchDate = data;
    },

    detail(val) {
      this.navigateTo({
        path: '/member/' + val.platform_user_id,
      });
    },

    loadLower(data) {
	  this.levelParams[this.higherLevel.platform_user_id || 0] = {
		  searchParams: this.$refs.search.get(),
		  pageIndex: this.$refs.table.pageIndex
	  }
      this.levelList.push(data);
    },

    backHigher() {
		delete this.levelParams[this.higherLevel.platform_user_id];
	    this.levelList.splice(this.levelList.length - 1, 1);
    },
	
	//总代云仓库存设置
	setStock(item) {
		this._setUserId = item.platform_user_id;
		this.$refs.stockEdit.open();
		this.$refs.stockForm.set({isStock: [1]});
		this.stockSearchHandle({isStock: [1]});
	},
	
	//总代库存查询
	stockSearchHandle(data) {
		data.member_user_id = this._setUserId;
		this.$refs.stockTable.load({
			url: '/member_user/get_product_sku_stock',
			data
		  });
	},
	
	//提交总代云仓库存设置数据
	setStockHandle(stop) {
		stop();
		
		var stockList = this.$refs.stockTable.getRow().filter(item => ((parseInt(item.data.revise_stock) || 0) !=0));
		
		if(stockList.length ==0){
			this.$message({
				text: '没有变更的库存数据！'
			});
			return;
		}
		
		this.request({
			url: '/member_user/set_product_sku_stock',
			data: {
				member_user_id: this._setUserId,
				product_sku_stock_list: Array.from(stockList, item => {
					return {
						product_id: item.data.product_id,
						product_sku: item.data.product_sku,
						product_count: parseInt(item.data.product_sku_stock) + (parseInt(item.data.revise_stock) || 0) 
					}
				})
			},
			loading: true,
			success: data => {
				this.$message({
					text: '云仓库存调整成功'
				});
                //刷新列表
                this.$refs.stockTable.update();
				// this.$refs.stockEdit.close();
			}
		});
	},
	
	batchSetStock() {
		let n = parseFloat(this.$refs.batchStockForm.serialize().value);
		if (n == n) {
			this.$refs.stockTable.getRow().forEach(item => {
				item.data.revise_stock = n;
			})
		}
		this.$refs.batchStockForm.clear();
	},
    //批量导出
    exportData() {
      var data = this.searchDate;
      data.job_id = 43;
      this.request({
          url: '/export_job/add',
          data: data,
          loading: true,
          success: data => {
              this.$message({
                  text: '导出任务提交成功，请稍后前往任务中心查看'
              });
          }
      });
    },
	//地址智能识别
	analysisAddress() {
	      if (!this.analysis_text || this.analysis_text.length == 0){
	          this.$message({
	              text: '请输入需要识别的内容',
	              icon: 'fail'
	          });
	          return false;
	      }
	      this.request({
	          url: '/platform_user/address/analysis',
	          data: {
	              text: this.analysis_text
	          },
	          loading: true,
	          timeout: false,
	          success: (data, message) => {
				  
				  data.nick_name = data.receiving_name;
				  data.user_manage_mobilephone = data.receiving_phone;
				  
				  data.province_id = data.receiving_address_province_id;
				  data.city_id = data.receiving_address_city_id;
				  data.county_id = data.receiving_address_county_id;
				  data.address_detail = data.receiving_address_details;
	              this.$refs.baseInfoForm.set(data);
	              this.$message({
	                  text: '智能识别成功',
	                  icon: 'success'
	              });
	          }
	      });
	},
  }
}
</script>